export default "__VITE_ASSET__DVEV1ryB__"